import { Organization as KaizenIdOrganization } from '@kaizenplatform/kaizen-id-entity';

class Organization extends KaizenIdOrganization {
  constructor({ id, name, profileImageUrl }: Pick<KaizenIdOrganization, 'id' | 'name' | 'profileImageUrl'>) {
    super({ id, name, profileImageUrl });
  }

  public static fromJSON = (value: any) => {
    const { id, name, profileImageUrl } = Object.assign({}, value);

    if (typeof id !== 'string') throw new TypeError('.id must be a string');
    if (typeof name !== 'string') throw new TypeError('.name must be a string');
    if (typeof profileImageUrl !== 'string') throw new TypeError('.profileImageUrl must be a string');

    return new Organization({
      id,
      name,
      profileImageUrl,
    });
  };
}

export default Organization;
